import { request, apiHeaders } from "./_base";
import { getFinancialYearSelected } from "./week";

const endpoint = "stockcheck";

export type StockCheckSummary = {
  "Location Code": string;
  FileImport_id: number;
  filename: string;
  timestamp: string;
  "File Age Days": number;
  "Total Pallets": number;
  Matched: number;
  Mismatched: number;
  "Missing On System": number;
  "Missing On File": number;
  Result: string;
};

export type StockCheckRow = {
  Barcode: string;
  "Sequence Number": number;
  "Location Code": string;
  "Farm Number": string;
  "Commodity Code": string;
  "Variety Code": string;
  "Pack Code": string;
  "Mark Code": string;
  "Grade Code": string;
  "Count Code": string;
  "Orig Intake Waybill": string;
  "No Cartons": number;
  "Pallet Size": number;
  edicomparisonerror?: string;
};

export const getStockCheckSummary = (): Promise<{ data: StockCheckSummary[] }> =>
  request(`${endpoint}/ext/getStockCheckSummary?fin_year=${getFinancialYearSelected()}`, {
    headers: apiHeaders(),
  }).then((result) => result.json());

export const getStockCheckDetail = (fileImportId: number): Promise<{ data: any[] }> =>
  request(`${endpoint}/ext/getStockCheckDetail/${fileImportId}`, {
    headers: apiHeaders(),
  }).then((result) => result.json());

export const getStockCheckSystemData = (fileImportId: number): Promise<{ data: StockCheckRow[] }> =>
  request(`${endpoint}/ext/getStockCheckSystemData/${fileImportId}`, {
    headers: apiHeaders(),
  }).then((result) => result.json());

export const getStockCheckFileData = (fileImportId: number): Promise<{ data: StockCheckRow[] }> =>
  request(`${endpoint}/ext/getStockCheckFileData/${fileImportId}`, {
    headers: apiHeaders(),
  }).then((result) => result.json());
